<h2>{{ 'error.header' | i18n }}</h2>
<div class="error">
  <p *ngFor="let e of messages">
    <span *ngIf="e | i18n" [innerHTML]=" e | i18n "></span>
    <span *ngIf="!(e | i18n)">{{ e }}</span>
  </p>
</div>

